import { ServiceFetch } from '../service-fetch'

export default class BorrowListModel extends ServiceFetch {
    getBorrowListBy = (data) => this.authFetch({
        url: 'borrow-list/getBorrowListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
 }